import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { camps } from '../../../../../../models/models.generated';
import { CampsDetailsFormStateService } from '../../../camp-details-form-state-service';

@Component({
    selector: 'app-session-details',
    templateUrl: './session-details.component.html',
    styleUrls: ['./session-details.component.scss'],
    standalone: false
})
export class SessionsDetailsComponent implements OnInit {
  
    @Input() public form : UntypedFormGroup;

    @Input() context: camps.CampDefinitionCreationContext;

    constructor(private state :CampsDetailsFormStateService) { 

    }

    ngOnInit(): void {
     
    }


    public get optionsForm(): UntypedFormGroup {
        return this.form.controls['options'] as UntypedFormGroup;
    }

    public get basicInfoForm(): UntypedFormGroup {
        return this.form.controls['basicInfo'] as UntypedFormGroup;
    }

    public get dayVariantsForm(): UntypedFormGroup {
        return this.form.controls['dayVariants'] as UntypedFormGroup;
    }

    public get pricingMatrixForm(): UntypedFormGroup {
        return this.form.controls['pricingMatrix'] as UntypedFormGroup;
    }

    public get isPricingMatrixVisible(): boolean {
        return this.form.controls['pricingMatrix'].value.items && this.form.controls['pricingMatrix'].value.items.length > 0;
    }

    public isEdited(form: UntypedFormGroup){
        return this.state.isEdited(form);
    }

    public isNew(){
        return !this.form.controls['id'];
    }
}
